import { bindActionCreators } from 'redux';

import makeConnect from '@utils/makeConnect';
import { actions } from '@modules/auth';

export default function UseAuth(resource) {

	const mapStateToProps = (state, ownProps) => ({
		...state.auth
	})

	const mapDispatchToProps = dispatch => ({
		actions: bindActionCreators(actions, dispatch)
	})

	return makeConnect(mapStateToProps, mapDispatchToProps)

}



// WEBPACK FOOTER //
// ./src/connects/auth.js